import { render, staticRenderFns } from "./Groundfloor.vue?vue&type=template&id=bf535e9e&scoped=true&"
import script from "./Groundfloor.vue?vue&type=script&lang=ts&"
export * from "./Groundfloor.vue?vue&type=script&lang=ts&"
import style0 from "./Groundfloor.vue?vue&type=style&index=0&id=bf535e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf535e9e",
  null
  
)

export default component.exports